module.exports = __webpack_public_path__ + "static/media/20_potolok_0.99_0.c15a067b.png";